import { useCurrentAccount } from "../providers/current-account-provider";
import { AccessControl } from "./access-control";
import AccountsSearch from "./accounts-search";
import { CustomFonts } from "./custom-fonts";
import { Footer } from "./footer";
import { Header } from "./header";
import { LeadGenerationPrompt } from "./lead-generation-prompt";
import { RegularSettings } from "./regular-settings";
import { Subscription } from "./subscription";
import SubscriptionLimitations from "./subscription-limitations";

export const Wrapper = () => {
  const { account } = useCurrentAccount();

  return (
    <div className="tw-rounded-lg tw-bg-white tw-shadow-dialog">
      <Header />
      <div className="tw-relative" key={account?._id}>
        <div className="scrollbar tw-max-h-[70vh] tw-w-[656px] tw-overflow-y-auto tw-p-10">
          <AccountsSearch />
          <RegularSettings />
          <hr className="tw-my-6 tw-border-t tw-border-blue-100" />
          <Subscription />
          <hr className="tw-my-6 tw-border-t tw-border-blue-100" />
          <AccessControl />
          <CustomFonts />
          <LeadGenerationPrompt />
          <SubscriptionLimitations />
        </div>
      </div>
      <Footer />
    </div>
  );
};
